import {
  Location,
  useDistanceTerminalContext,
  useTenantConfig,
  useToast,
} from 'contexts';
import { t } from 'i18n';

enum LocationStatus {
  PROMPT = 'prompt',
  GRANTED = 'granted',
  DENIED = 'denied',
  NOT_SUPPORTED = 'not-supported',
}

export const useGetDistanceTerminal = () => {
  const toast = useToast();
  const { epicOmni1589, isMobile } = useTenantConfig();

  const {
    getDistanceLocation,
    setIsModeEnterAddress,
    setMessageError,
    permissionGetLocationStatus,
    setTemporaryDataDistanceTerminal,
    temporaryDataDistanceTerminal,
  } = useDistanceTerminalContext();

  const handleErrorWhenNotExistTerminal = () => {
    setMessageError?.(
      t(
        'Rất tiếc, chúng tôi chưa phục vụ giao hàng tại khu vực này. Quý khách vui lòng chọn địa chỉ nhận hàng khác. Cảm ơn quý khách!',
      ),
    );
  };

  const requestLocation = (callBack?: () => void) => {
    if (
      permissionGetLocationStatus === LocationStatus.PROMPT ||
      permissionGetLocationStatus === LocationStatus.GRANTED
    ) {
      callBack?.();
    } else if (permissionGetLocationStatus === LocationStatus.DENIED) {
      setMessageError?.(
        t(
          isMobile
            ? 'Vui lòng cấp quyền truy cập vị trí cho trình duyệt tại cài đặt của thiết bị.'
            : 'Vui lòng cấp quyền truy cập vị trí cho trình duyệt tại cài đặt của trình duyệt đang sử dụng.',
        ),
      );
    } else if (permissionGetLocationStatus === LocationStatus.NOT_SUPPORTED) {
      setMessageError?.(t('Định vị không khả dụng trên trình duyệt của bạn'));
    }
  };

  const getDistanceTerminalsByGeoLocation = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const terminals = await getDistanceLocation?.({
            lat: position.coords.latitude,
            long: position.coords.longitude,
          });
          if (!!terminals && terminals?.length > 0) {
            setIsModeEnterAddress?.(false);
            setTemporaryDataDistanceTerminal?.({
              ...temporaryDataDistanceTerminal,
              terminals,
            });
          } else {
            handleErrorWhenNotExistTerminal();
          }
        },
        (err) => {
          toast.error?.({ title: t('Lỗi'), message: err.message });
        },
      );
    } else {
      toast.error?.({
        title: t('Lỗi'),
        message: t('Geolocation không được hỗ trợ trên trình duyệt của bạn.'),
      });
    }
  };
  const getDistanceTerminalsByAddress = async (data: Location) => {
    const { provinceName, wardName, districtName, lat, long } = data;
    const terminals = await getDistanceLocation?.({
      address: epicOmni1589
        ? `${data.address}, ${wardName}, ${provinceName}`
        : `${data.address}, ${wardName}, ${districtName}, ${provinceName}`,
      lat,
      long,
    });
    if (!!terminals && terminals?.length > 0) {
      setIsModeEnterAddress?.(false);
      setTemporaryDataDistanceTerminal?.({
        ...temporaryDataDistanceTerminal,
        location: {
          ...data,
          provinceName,
          wardName,
          districtName,
          lat,
          long,
        },
        terminals,
      });
    } else {
      handleErrorWhenNotExistTerminal();
    }
  };

  return {
    getDistanceTerminalsByGeoLocation,
    getDistanceTerminalsByAddress,
    requestLocation,
  };
};
